import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import * as s from "./index.module.scss";
import { BsArrowUpRight } from "react-icons/bs";
import { PrismicRichText } from "@prismicio/react";
import WatchPopups from "@/components/Common/WatchPopups";
import secondaryFont from "@/utils/secondaryFont";
import Popups from "../../../components/Common/Popups";

const RolexWatchesGrid = ({ title, description, watches, models, styles }) => {
  const [pages, setPages] = useState([]);
  const [paginatedItems, setPaginatedItems] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const noOfItemsPerPage = watches.length / 12;

  useEffect(() => {
    for (let i = 0; i <= noOfItemsPerPage; i++) {
      setPages([...pages, i]);
    }
  }, []);
  const [showModal, setShowModal] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  const [showID, setID] = useState();

  return (
    <section className={`section-center ${s.rolex_watches} ${styles ? s.rolex_watch_only_content : ""  }`}>
      <Container>
        <div>
          <div className={s.title}>
            <h2 className="title fw-bold">{title}</h2>
            <div className={`${secondaryFont} title`}>
              <PrismicRichText field={description || []} />
            </div>
          </div>

          {models && (
            <div className={`${s.models_container} ${secondaryFont}`}>
              <PrismicRichText field={models || []} />
            </div>
          )}

          <div>
            {/* <Pagination watches={watches}/> */}
            <div className={s.rolex_grid}>
              {watches.map(({ data, uid }, idx) => {
                return (
                  <div key={idx} className={s.single_watch}>
                    <div>
                      <div className={s.watch}>
                        <img
                          loading="lazy"
                          src={data?.watch_image.url}
                          alt={data?.watch_image.url || "image"}
                        />
                      </div>

                      <h5 className="fw-bold">{data?.watch_name}</h5>
                      <p className={`${secondaryFont} sub-title`}>
                        {data?.watch_brand}
                      </p>
                    </div>
                    <div className="d-xxl-flex justify-content-center gap-2">
                      <button
                        className={`btn btn-primary mb-2 mb-xxl-0 w-100  ${s.button_sell}`}
                        onClick={() => {
                          setShowSellModal(true);
                        }}
                      >
                        Sell Now
                      </button>
                      {data?.watch_description[0].text && (
                        <button
                          onClick={() => {
                            setShowModal(true);
                            setID(uid);
                          }}
                          className={`btn btn-outline-dark ${s.button_view}`}
                        >
                          View more
                          <BsArrowUpRight style={{ marginLeft: "8px" }} />
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
      <WatchPopups
        show={showModal}
        dataID={showID}
        watcheDetail={watches}
        onHide={() => {
          setShowModal(false), setID(0);
        }}
      />
      <Popups
        show={showSellModal}
        onHide={() => {
          setShowSellModal(false);
        }}
      />
    </section>
  );
};

// const Pagination = ({ }) => {
//   const [itemOffset, setItemOffset] = useState(0);

//   const endOffset = itemOffset + itemsPerPage;
//   const currentItems = watches.slice(itemOffset, endOffset);
//   const pageCount = Math.ceil(watches.length / itemsPerPage);
//   const itemsPerPage = 12;

//   const handlePageClick = (event) => {
//     const newOffset = (event.selected * itemsPerPage) % watches.length;
//     setItemOffset(newOffset);
//   };

//   return (
//     <>
//       <ReactPaginate
//         breakLabel="..."
//         nextLabel=">"
//         onPageChange={handlePageClick}
//         pageRangeDisplayed={5}
//         pageCount={pageCount}
//         previousLabel="<"
//         renderOnZeroPageCount={null}
//         containerClassName="pagination"
//         pageLinkClassName='page-num'
//         previousLinkClassName='page-num'
//         nextClassName='page-num'
//         activeClassName='active'
//       />
//     </>
//   );
// }

export default RolexWatchesGrid;
